import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PessoaExamePeriodicidadeConsultaDto, PessoaExamePeriodicidadeEdicaoDto, PessoaExamePeriodicidadeInsercaoDto } from '../dtos/periodicidades/pessoa-exame-periodicidade';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class PessoaExamePeriodicidadeService {

  constructor(private http: HttpClient, private url: UrlService) { }

  consultar(id: number): Observable<PessoaExamePeriodicidadeConsultaDto> {
    return this.http
      .get<PessoaExamePeriodicidadeConsultaDto>(this.url.url(`pacientes/exames-periodicidades/${id}`));
  }

  listar(pessoaId: number): Observable<PessoaExamePeriodicidadeConsultaDto[]> {
    let params = new HttpParams();
    params = params.append('pessoaId', '' + pessoaId);

    return this.http
      .get<PessoaExamePeriodicidadeConsultaDto[]>(this.url.url(`pacientes/exames-periodicidades/`), {
        params: params
      });
  }

  salvar(dto: PessoaExamePeriodicidadeInsercaoDto | PessoaExamePeriodicidadeEdicaoDto): Observable<PessoaExamePeriodicidadeConsultaDto> {
    if('id' in dto && dto.id !== null && dto.id > 0) {
      return this.http
      .put<PessoaExamePeriodicidadeConsultaDto>(this.url.url(`pacientes/exames-periodicidades/`), dto);
    }

    return this.http
      .post<PessoaExamePeriodicidadeConsultaDto>(this.url.url(`pacientes/exames-periodicidades/`), dto);
  }
}
